/**
 * Normalize year of manufacture to a 4-digit YYYY string, or empty string.
 */
export const normalizeYearOfManufacture = (value) => {
  if (value == null || value === "") return "";

  const str = String(value).trim();
  if (!str) return "";

  const leadingYear = str.match(/^(\d{4})/);
  if (leadingYear) return leadingYear[1];

  const embeddedYear = str.match(/\b(19|20)\d{2}\b/);
  if (embeddedYear) return embeddedYear[0];

  const numeric = parseInt(str, 10);
  if (!Number.isNaN(numeric) && numeric >= 1900 && numeric <= 2100) {
    return String(numeric);
  }

  return "";
};

export const formatYearOfManufacture = (value) =>
  normalizeYearOfManufacture(value);
